import { AxiosRequestConfig } from 'axios';

export class TokenExpired extends Error {
  constructor(public config: AxiosRequestConfig, msg: string = 'The token has expired') {
    super(msg);
  }
}
